import { render, staticRenderFns } from "./chengji.vue?vue&type=template&id=704208cb&scoped=true&"
import script from "./chengji.vue?vue&type=script&lang=js&"
export * from "./chengji.vue?vue&type=script&lang=js&"
import style0 from "./chengji.vue?vue&type=style&index=0&id=704208cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704208cb",
  null
  
)

export default component.exports